export const membershipTranslationsEn = {
  MembershipCreate: {
    errors: {
      membershipDoesAlreadyExist: 'This employee is already part of your company',
      userDoesNotExist: 'There is no user with the entered email address',
    },
    title: 'Add employee',
    invitationSentNotificationTitle: 'Invitation was sent out',
    invitationSentNotificationBody: 'Your employee will receive an e-mail with all further steps.',
  },
  MembershipEdit: {
    roleSuccess: 'Role successfully updated',
  },
  MembershipsAll: {
    add: {
      emailDuplicateHint: 'This email was already added.',
      emailInvalidHint: 'This email is in an invalid format.',
    },
    delete: {
      title: 'Remove {name}',
      description:
        'You will be added as an editor to all projects in which {name} is currently the only editor.\n\nThis action cannot be undone.',
      success: 'Employee successfully removed',
    },
    inviteAgainCTA: 'Send invitation again',
    invitationEmailSentAgainTitle: 'Invitation e-mail sent again',
    invitationEmailSentAgainSubtitle:
      '{email} has once again received an invitation to your company.',
  },
  MembershipsActivity: {
    lastActive: 'Last active',
    lastWeek: 'last week',
    lastMonth: 'last month',
    lastSixMonths: 'last 6 months',
    moreThanSixMonths: 'more than 6 months ago',
    never: 'never',
  },
};
